import React, { Component } from "react";
import { connect } from 'react-redux';
import { hideOperacion, setOperacion } from "../redux/actions";
import M from 'materialize-css';

class InternetStatusManager extends Component {

    state = {
        timeoutId: false
    }


    componentDidMount() {
        window.addEventListener('offline', this.handleOffline);
        //window.addEventListener('online', this.handleOnline);
    }

    componentWillUnmount() {
        window.removeEventListener('offline', this.handleOffline);
        // window.removeEventListener('online', this.handleOnline);
    }

    handleOffline = () => {
        this.props.setOperacion({ opt: "sinInternet", title: "Cerrar" });
    };

    // Función que se ejecuta cuando la conexión vuelve (opcional pero recomendado).
    // handleOnline = () => {
    //     this.props.hideOperacion();

    // };

    render() {
        return null;
    }

}


export default connect(null,
    {
        setOperacion,
        hideOperacion
    }
)(InternetStatusManager);